module.exports = __webpack_public_path__ + "static/media/batuhan1.7424b9bb.jpg";